import React from "react";
import { CURRENCY } from "../../../contants";
import price from "../../../helpers/calculatePrice";

const ItemCard = ({ item, onClick, getImageUrl, tableType }) => {
  const hasVariants = item?.variants && item.variants.length > 0;

  return (
    <div
      className="card item-card h-100 shadow-sm cursor-pointer"
      onClick={onClick}
    >
      <div className="item-image-placeholder bg-light">
        {item.itemImage ? (
          <img
            src={getImageUrl(item)}
            alt={item.itemName}
            className="w-100 h-100 item-img"
            style={{ objectFit: "cover" }}
            onError={(e) => {
              e.target.style.display = "none";
              e.target.parentElement.textContent = "Image";
            }}
          />
        ) : (
          "Image"
        )}
      </div>
      <div className="card-body p-2">
        <h6 className="card-title font-weight-bold mb-1 small">
          {item.itemName}
        </h6>
        {hasVariants ? (
          <div className="text-primary font-weight-bold">Variants</div>
        ) : (
          <div className="text-primary font-weight-bold">
            {CURRENCY}
            {price(tableType, item) || item.itemPrice}
          </div>
        )}
      </div>
    </div>
  );
};

export default ItemCard;
